import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import '@css/index.css'

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'default-passive-events'
Vue.use(Element)

Vue.config.productionTip = false

import common from '@/utils/common.js';
Vue.prototype.$common = common;

import Head from '@/components/Container/HeaderTwo'
Vue.component('Head', Head)

// 引入指令
import directive from '@/utils/directive';
Vue.use(directive)

new Vue({
	store,
	router,
	render: (h) => h(App)
}).$mount('#app')
